import React from 'react';

export default function Box(props: {
    classMame?: string;
    numer: number;
    title: string;
    content: string;
}) {
    return (
        <div className={`flex items-center ${props.classMame}`}>
            <div className={'text-5xl text-SM-yellow'}>{props.numer}</div>
            <div className={'ml-3'}>
                <h3 className={'font-medium'}>{props.title}</h3>
                <p>{props.content}</p>
            </div>
        </div>
    );
}
